import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nContext";
import { User, Mail, Shield, Building2 } from "lucide-react";

export default function Settings() {
  const { user } = useAuth();
  const { t } = useI18n();
  const isAdmin = user.role === "superadmin";
  const rows = [
    { icon: User, label: t("dash.s_name"), value: user.name },
    { icon: Mail, label: t("dash.s_email"), value: user.email },
    { icon: Shield, label: t("dash.s_role"), value: isAdmin ? t("dash.roleAdmin") : t("dash.roleClient") },
  ];
  return (
    <div>
      <h1 className="font-display font-bold text-3xl text-white">{t("dash.settingsTitle")}</h1>
      <p className="mt-1 text-zinc-400">{t("dash.settingsSub")}</p>

      <div className="mt-6 rounded-2xl border border-white/10 bg-[#0d0d14] p-6 max-w-xl divide-y divide-white/10" data-testid="settings-account">
        {rows.map((r) => (
          <div key={r.label} className="flex items-center gap-4 py-4 first:pt-0 last:pb-0">
            <span className="w-10 h-10 rounded-xl glass flex items-center justify-center text-cyan-400"><r.icon className="w-5 h-5" /></span>
            <div><p className="text-xs text-zinc-500">{r.label}</p><p className="text-white">{r.value}</p></div>
          </div>
        ))}
      </div>

      <div className="mt-4 rounded-2xl border border-white/10 bg-[#0d0d14] p-6 max-w-xl">
        <div className="flex items-center gap-3">
          <Building2 className="w-5 h-5 text-cyan-400" />
          <p className="text-sm text-zinc-400">{t("dash.changeCreds")}</p>
        </div>
      </div>
    </div>
  );
}
